import { AuthContext } from '@repo-level/core-front';
import { LootboxStage } from 'api/common';
import { RealTimeServiceContext } from 'contexts/realTimeService';
import { groupMemberCommonVIP } from 'helpers/user';

import { useContext } from 'react';
import {
  CLOVER_CASUAL_LOOTBOX_GROUP_KEY,
  CLOVER_VIP_LOOTBOX_GROUP_KEY,
} from '../helpers';

export const useIsCloverBonusIssued = () => {
  const { user } = useContext(AuthContext);
  const { lootboxes } = useContext(RealTimeServiceContext);

  const isVIP = groupMemberCommonVIP(user);
  const groupKey = isVIP
    ? CLOVER_VIP_LOOTBOX_GROUP_KEY
    : CLOVER_CASUAL_LOOTBOX_GROUP_KEY;

  const isIssued = lootboxes.some(
    (l) => l.groupKey === groupKey && l.stage === LootboxStage.Issued
  );

  return { isIssued };
};
